import React, { useEffect, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    DialogActions,
    Box,
    Button,
    Divider,
    Alert,
    Typography
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { FormProvider, useForm } from "react-hook-form"

import styles from 'components/modal/modal.module.css';
import ClearIcon from '@mui/icons-material/Clear';

import Loader from 'components/Loader';


const DialogSubmit = (Props) => {
    const { open, setOpen, handleSubmit, data, handleOpenSubmit, title, fileType, message, type, loading } = Props
    const methods = useForm()

    useEffect(() => {
        methods.reset()
    }, [open])

    const Submit = () => {
        handleOpenSubmit?.(false, true,data)

    }



    return (
        <FormProvider {...methods}>

            <Loader loading={loading} />
            <Dialog open={open} onClose={() => handleOpenSubmit(false, true)} >

                <Box className={styles.backgroundModal}>
                    <Box className={styles.boxModal}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '720px' }}>
                            <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                <Box sx={{ border: `5px solid ${type === 'error' ? '#B22222' : '#478F96'}` }} />
                                <Box sx={{
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    color: '#478F96',
                                    "@media (max-width: 800px)": {
                                        fontSize: '16px',
                                    }
                                }}> <Typography sx={{ fontSize: 16 }}>{fileType ? `Export ${fileType} -` : ''}{title}</Typography> </Box>
                            </Box>
                            <Box sx={{ '&:hover': { cursor: 'pointer' } }} onClick={() => handleOpenSubmit(false, true)}>
                                <IconButton>
                                    <ClearIcon />
                                </IconButton>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'grid', gridGap: '20px' }}>
                            <Box sx={{ height: '55px' }}>
                                {/* <Alert severity="success"></Alert> */}
                            </Box>
                            <Box sx={{ display: 'grid', gridGap: '20px', gridTemplateColumns: '1fr 1fr', justifyItems: 'center' }}>
                                <Button variant='contained' sx={{ width: '100%' }} color="error" onClick={() => handleOpenSubmit(false, true)} >ปิด</Button>
                                <Button variant='contained' sx={{ width: '100%' }} onClick={() => Submit()} >ยืนยัน</Button>
                            </Box>


                        </Box>
                    </Box>
                </Box>
                <DialogTitle
                    sx={{
                        boxShadow: "0px 0px 10px 1px #D4D4D4",
                        padding: "5px 20px",
                        textAlign: "center",
                        backgroundColor: "#3671B7",
                        color: "white",
                    }}
                >
                    {title}
                </DialogTitle>



            </Dialog>
        </FormProvider>
    )
}

export default DialogSubmit
